(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ApplicationFeatureEntityMapSearch', ApplicationFeatureEntityMapSearch);

    ApplicationFeatureEntityMapSearch.$inject = ['$resource'];

    function ApplicationFeatureEntityMapSearch($resource) {
        var resourceUrl =  'api/_search/application-feature-entity-maps/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
